<div class="new-diversion">
    <rt-new-diversion
        [tripIds]="tripIds"
        (diversionCreated)="onDiversionCreated()"
        (diversionCancelled)="onDiversionCancelled()"
    >
    </rt-new-diversion>
</div>
